export interface FilterablePost {
  title: string
  excerpt?: string
  categories?: { title: string; slug: string }[]
}

/** Lowercase + strip diacritics so "securite" matches "Sécurité". */
const normalize = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export function filterPosts<T extends FilterablePost>(
  posts: T[],
  category: string | null,
  query: string,
): T[] {
  const q = normalize(query.trim())
  return posts.filter((post) => {
    if (category && !post.categories?.some((c) => c.slug === category)) return false
    if (!q) return true
    return normalize(`${post.title} ${post.excerpt ?? ''}`).includes(q)
  })
}
